<template>
  <div
    class="select-wrapper relative"
    @click="toggle()"
    v-click-outside="close"
  >
    <div class="select" :class="{ selected: defaultText !== selectedText }">
      <div class="flex flex-row items-center overflow-hidden gap-2 flex-1">
        <p
          class="text-xs overflow-ellipsis overflow-hidden whitespace-nowrap w-full !font-bold dark:text-secondary-100"
        >
          {{ selectedText }}
        </p>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="min-w-[18px] feather feather-chevron-down"
        :class="{ expanded: visible }"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </div>
    <div
      class="option_list option_list--select_list !overflow-visible"
      :class="{ hidden: !visible }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectList",
  props: {
    defaultText: {
      type: String,
      default: "Select List",
    },
    selections: Array,
    options: Array,
  },
  data() {
    return {
      visible: false,
      text: "",
    };
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    close(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.visible = false;
      }
    },
    getItem(value, index) {
      return this.options[index]?.find((item) => item.value === value) ?? null;
    },
  },
  computed: {
    selectedText() {
      let text = "";
      this.selections.forEach((select, index) => {
        select.forEach((element) => {
          text = `${text}, ${this.getItem(element, index).text}`;
        });
      });
      return text.length ? text.substring(2) : this.defaultText;
    },
  },
};
</script>

<style>
@import "index.module.css";
</style>
